import React, { useState } from "react";
import { Row, Container, Col } from "react-bootstrap";
import AddSocial from "../../components/Creator/AddSocial";
import SocialTile from "../../components/Creator/SocialTile";

export default function CreatorDashboard(props) {
  const user = props.user;
  const [socials, setSocials] = useState(user.Socials || []);
  const listSocials = (socials) => {
    return socials.map((social) => (
      // <div
      //   className="col-lg-4"
      //   style={{ backgroundColor: "#d3d3d3" }}
      //   key={social.id}
      // >
      <Col>
        <SocialTile social={social} />
      </Col>
    ));
  };
  return (
    <Container>
      <h2>Creator Home</h2>
      <div>
        {!socials || socials.length === 0 ? (
          <div>
            <h3>You have no socials, add some:</h3>
            <AddSocial
              setSocials={setSocials}
              socials={socials}
              jwt={props.jwt}
            />
          </div>
        ) : (
          <div>
            <h3>My socials</h3>
            <Row>
              {listSocials(socials)}
              <Col>
                {/* <div className="col-lg-4" style={{ backgroundColor: "#d3d3d3" }}> */}
                <AddSocial
                  setSocials={setSocials}
                  socials={socials}
                  jwt={props.jwt}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>
    </Container>
  );
}
